import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddSubscriptionDTO, EditSubscriptionStatusDTO, } from "../../dtos/category";
import SubscriptionService from "./SubscriptionService";

// Define initial state
const initialState = {
  subscriptionDetails: [],
  editSubscriptionPayload: null,
  subscriptionId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",

  isSubscriptionLoading: false,
  isEditSubscriptionLoading: false,

  isEditSubscriptionSuccess: false,

  isSubscriptionLoadingError: false,
  isEditSubscriptionLoadingError: false,

  regEditSubscriptionMessage: "",
};

export const AddSubscription = createAsyncThunk(
  "/api/pharmacy/subscription/add",
  async (subscription: AddSubscriptionDTO, thunkAPI) => {
    try {
      return await SubscriptionService.AddSubscription(subscription);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSubscriptionData = createAsyncThunk(
  "subscription/getSubscriptionData", 
  async (_, thunkAPI) => {
    try {
      const response = await SubscriptionService.getSubscription(); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getStatus = createAsyncThunk(
  "subscription/getSubscriptionStatus", 
  async (pharmacy_id: any, thunkAPI) => {
    try {
      const response = await SubscriptionService.getSubscriptionStatus(pharmacy_id); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const editSubscriptionStatus = createAsyncThunk(
  "status/edit",
  async (dto: EditSubscriptionStatusDTO, thunkAPI) => {
    try {
      return await SubscriptionService.editSubscriptionStatus(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const SubscriptionSlice = createSlice({
  name: "SubscriptionSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeSubscriptionId: (state, action) => {
      state.subscriptionId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

    .addCase(AddSubscription.pending, (state) => {
      state.isEditSubscriptionLoading = true;
    })
    .addCase(
      AddSubscription.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isEditSubscriptionLoading = false;
        state.isEditSubscriptionSuccess = true;
        state.isEditSubscriptionLoadingError = false;
        state.regEditSubscriptionMessage = "";
        state.editSubscriptionPayload = action.payload;
      }
    )
    .addCase(
      AddSubscription.rejected,
      (state, action: PayloadAction<any>) => {
        state.isEditSubscriptionLoading = false;
        state.isEditSubscriptionLoadingError = true;
        state.regEditSubscriptionMessage = action.payload;
      }
    )
      .addCase(getSubscriptionData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSubscriptionData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.subscriptionDetails = action.payload;
        state.message = "";
      })
      .addCase(getSubscriptionData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });


  },
});

// Export actions and reducer
export const { reset, changeSubscriptionId } = SubscriptionSlice.actions;
export default SubscriptionSlice.reducer;
